import React from "react";
import { Crosshair, GitBranch, MonitorSmartphone } from "lucide-react";

/** Screen vs Platform toggle, picked per question. */
export function ScopeToggle({ scope, setScope, testid }) {
  return (
    <div className="inline-flex rounded-full border border-white/10 overflow-hidden" role="radiogroup" data-testid={testid}>
      {[["screen", "Screen"], ["platform", "Platform"]].map(([k, l]) => (
        <button key={k} type="button" role="radio" aria-checked={scope === k} onClick={() => setScope(k)} data-testid={`${testid}-${k}`}
          title={k === "screen" ? "Fast — only what's on this screen" : "Traces the issue across every engine to the true source"}
          className={`px-2.5 py-0.5 font-mono text-[9px] uppercase tracking-[0.14em] transition-colors ${scope === k ? "bg-brand-cyan/15 text-brand-cyan" : "text-slate-400 hover:text-slate-200"}`}>{l}</button>
      ))}
    </div>
  );
}

/** Platform-mode trace: where it shows, where it's caused, what else the same cause touches. */
export function TraceCard({ trace, testid }) {
  if (!trace || (!trace.appears_on && !trace.root_cause?.engine)) return null;
  const rc = trace.root_cause || {};
  return (
    <div data-testid={testid} className="mt-2 rounded-md border border-amber-400/25 bg-amber-500/[0.04] p-3 space-y-2 text-xs">
      <div className="flex gap-2"><MonitorSmartphone className="h-3.5 w-3.5 text-slate-400 shrink-0 mt-0.5" />
        <div><span className="text-slate-400">Appears on: </span><span className="text-slate-200" data-testid={`${testid}-appears`}>{trace.appears_on || "—"}</span></div></div>
      <div className="flex gap-2"><Crosshair className="h-3.5 w-3.5 text-amber-300 shrink-0 mt-0.5" />
        <div data-testid={`${testid}-root`}><span className="text-slate-400">Root cause: </span><span className="text-amber-200">{rc.engine}</span>{rc.where ? <span className="text-slate-200"> · {rc.where}</span> : null}
          {rc.why && <div className="text-slate-300 mt-0.5">{rc.why}</div>}</div></div>
      {trace.connected?.length > 0 && (
        <div className="flex gap-2"><GitBranch className="h-3.5 w-3.5 text-sky-300 shrink-0 mt-0.5" />
          <div data-testid={`${testid}-connected`}><span className="text-slate-400">Also affected:</span>
            <ul className="mt-0.5 space-y-0.5">{trace.connected.map((c, i) => <li key={i}><span className="text-sky-200">{c.engine}</span><span className="text-slate-300"> — {c.how}</span></li>)}</ul></div></div>
      )}
    </div>
  );
}
